/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';
import { AuthState, Customer } from './types';

export const actions: ActionTree<AuthState, RootState> = {
  fetchCustomer({ commit }): Promise<Customer> {
    commit('customerLoading');

    return new Promise((resolve, reject) => {
      this.state.$http.get('customer', getApiRequestConfig(ApiEndpointEnum.AuthAPI))
        .then((response: AxiosResponse<Customer>) => {
          const payload: Customer = response && response.data;
          commit('customerLoaded', payload);
          resolve(payload);
        }, (error) => {
          commit('customerError', error);
          reject(error);
        });
    });
  },
};
